import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsideUtilsService {

  private navLogoURLUpdated$: Subject<string> = new Subject<string>();

  public updateNavLogoURL(navLogoURL: string): void {
    this.navLogoURLUpdated$.next(navLogoURL);
  }

  public onNavLogoURLUpdated(): Observable<string> {
    return this.navLogoURLUpdated$.asObservable();
  }

}
